import categoriesData from './categories.json';

class YelpCategory {
    constructor(alias, title, parents, countryBlacklist, countryWhitelist) {
        this.alias = alias;
        this.title = title;
        this.parents = parents || [];
        this.countryBlacklist = countryBlacklist || [];
        this.countryWhitelist = countryWhitelist || [];
    }
}

class YelpCategories {
    static #initialized = false;
    static #categories = [];

    static initializeData() {
        if (!this.#initialized) {
            // Load the pre-filtered categories
            this.#categories = require('./categories.json');
            this.#initialized = true;
        }
    }

    static getCategories() {
        if (!this.#initialized) {
            this.initializeData();
        }
        return this.#categories;
    }

    static getCategory(alias) {
        if (!this.#initialized) {
            this.initializeData();
        }
        return this.#categories.find(cat => cat.alias === alias);
    }

    static getCategoryChildren(parentAlias) {
        if (!this.#initialized) {
            this.initializeData();
        }
        return this.#categories.filter(cat => 
            cat.parents && cat.parents.includes(parentAlias)
        );
    }

    static getCategoryParents(alias) {
        if (!this.#initialized) {
            this.initializeData();
        }

        if (!alias) {
            return null;
        }

        const category = this.#categories.find(cat => cat.alias === alias);
        if (!category) {
            return null;
        }

        return category.parents
            .map(parentAlias => this.#categories.find(cat => cat.alias === parentAlias))
            .filter(Boolean)
            .filter(cat => cat.title.trim() !== '');
    }

    static getTopLevelCategories() {
        if (!this.#initialized) {
            this.initializeData();
        }

        return this.#categories.filter(cat => cat.parents.length === 0 && cat.title.trim() !== '');
    }

    static getFlattenedCategories() {
        return this.#categories;
    }

    static setFilteredCategories(categories) {
        this.#categories = categories;
    }

    static clearFilters() {
        this.#categories = require('./categories.json');
    }
}

export default YelpCategories; 